import { RadialBar } from "@ant-design/plots"
import { Progress, Space } from "antd"
import cx from "clsx"
import dayjs from "dayjs"
import { t } from "i18next"
import { MdAutoGraph } from "react-icons/md"
import { Flex, Tag, Text, Skeleton } from "../../common"
import styles from "./index.module.less"
import { convertToHMSString } from "utils"

const getLast7DaysRange = () => {
  const currentDate = dayjs() // Current date
  const last7DaysDate = currentDate.subtract(6, "day") // Subtract 7 days
  return {
    startDate: last7DaysDate.format("MMM DD"), // Format as needed
    endDate: currentDate.format("MMM DD"),
  }
}

const DemoRadialBar = ({ data, tabExtraFilter, loading, queryObj }) => {
  const config = {
    data: data?.radialData,
    xField: tabExtraFilter ? tabExtraFilter + "Title" : "CompletionPercentageTitle",
    yField: tabExtraFilter ? tabExtraFilter + "Value" : "CompletionPercentageValue",
    maxAngle: 340,
    radius: data?.radialData?.length >= 4 ? 0.85 : 0.71,
    innerRadius: data?.radialData?.length <= 1 ? 0.9 : data?.radialData?.length <= 3 ? 0.6 : 0.4,
    tooltip: {
      customContent: (data, items) => {
        let tabExtra = tabExtraFilter || "CompletionPercentage"
        let customData = items?.[0]?.data
        let title = customData?.title

        let date =
          tabExtra === "CompletionPercentage"
            ? queryObj?.fromDate && queryObj?.toDate
              ? `${dayjs(decodeURIComponent(queryObj?.fromDate)).format("MMM DD")} - ${dayjs(
                  decodeURIComponent(queryObj?.toDate)
                ).format("MMM DD")} `
              : ` ${getLast7DaysRange().startDate} - ${getLast7DaysRange().endDate} `
            : dayjs().format("MMMM YYYY")

        let probability = customData?.probability
        let requiredAchievement = customData?.requiredAchievement
        let achievementValue = customData?.[tabExtra]?.achieved
        let achievedValue = customData?.[tabExtra]?.target
        let percentage = customData?.[tabExtra]?.percentage
        let type = customData?.[tabExtra]?.targetType

        return (
          <div style={{ width: type === "time" ? 420 : 310 }}>
            <Flex
              align="start"
              gap="4px"
              vertical
              style={{ paddingBlock: "14px", paddingBottom: probability === undefined ? "0px" : "14px" }}
            >
              <Flex className="mbe-16 w-100" justify="space-between">
                <Flex gap="4px">
                  <span className="fs14 bold">{title}</span> <span className="gray-900 fw-medium fs10">({date})</span>
                </Flex>
                <Flex gap="4px">
                  <span className="fs14">
                    {type === "time" ? convertToHMSString(achievementValue) : Math.round(achievementValue)}
                  </span>
                  <span className="gray-900 fs12">
                    /{type === "time" ? convertToHMSString(achievedValue) : Math.round(achievedValue)}
                  </span>
                  <span className="fw-medium text-primary fs12 text-primary">({Math.round(percentage)}%)</span>
                </Flex>
              </Flex>
              {probability === undefined ? null : (
                <>
                  <Flex className="mbe-0 w-100" gap="8px" justify="space-between">
                    <div>
                      <MdAutoGraph size="14px" className="text-primary" style={{ marginInlineEnd: "4px" }} />
                      <Text type="secondary" className="fw-medium">
                        {t("Monthly Target Prediction")}
                      </Text>
                    </div>
                    <Tag type="light" pill color="#009F2B" style={{ margin: 0, transition: "none" }}>
                      {`${Math.round(probability)}%`}
                    </Tag>
                  </Flex>
                  <Progress percent={probability} showInfo={false} className={cx("mbe-4", styles.progressTransition)} />
                  <p className="fs12 gray-900 lhn mbe-0">
                    Almost There! You need an average of<span className="bold pi-4">{requiredAchievement}</span>
                    per day to hit your target.
                  </p>
                </>
              )}
            </Flex>
          </div>
        )
      },
    },
    barBackground: {
      style: {
        fill: data?.radialData?.[0]?.targetColor,
      },
    },
    scale: {
      y: {
        domain: [0, 100],
      },
    },
    barStyle: {
      fillOpacity: 1,
    },
    colorField: "achievedColor",
    color: ({ achievedColor }) => {
      return achievedColor
    },
  }

  return loading ? (
    <Skeleton type="input" width={400} height={300} active={true} />
  ) : (
    <RadialBar className={styles.RadialBar} loading={loading} disabled={loading} {...config} />
  )
}

export default DemoRadialBar
